import { render, staticRenderFns } from "./AIChat_Price.vue?vue&type=template&id=3a1419b4&scoped=true"
import script from "./AIChat_Price.vue?vue&type=script&lang=js"
export * from "./AIChat_Price.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Price.vue?vue&type=style&index=0&id=3a1419b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1419b4",
  null
  
)

export default component.exports